export default __webpack_public_path__ + "static/media/opvs.bd1a7639.svg";